import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {MatRippleModule} from '@angular/material/core';
import { NgIf} from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CallingDataService } from '../../shared/services/calling-data.service';

@Component({
  selector: 'vex-calling-layout',
  templateUrl: './calling-layout.component.html',
  styleUrl: './calling-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatDialogModule,
    MatRippleModule,
    NgIf
  ],
  providers: [CallingDataService]
})
export class CallingLayoutComponent implements OnInit {
  @ViewChild('callingModal') callingModal: TemplateRef<any>;
  hideCallingIcon: any = true;
  callData: any;

  constructor(protected dialog: MatDialog,) {
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
  }

  openCallingModal() {
    this.dialog.open(this.callingModal, {
      width: '30vw',
      minWidth: '350px'
    });
  }
}

